const BASE_64_TRANSPARENT_GIF_SRC =
  'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

export default BASE_64_TRANSPARENT_GIF_SRC;
